import React, { FC, useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import { getFocusPage } from '@/actions/actions'
import { PageContent } from '@/components/PageContent/PageContent'
import { pageTypes } from '@/constants/common'
import { TabsPage } from '@/containers/TabsPage'
import useStore from '@/store/useStore'

export const FocusPage: FC = () => {
  const { search } = useLocation()
  const { page, setPage } = useStore((state) => state.page)
  const isTabPage = page?.pageType === pageTypes.TABS

  useEffect(() => {
    const controller = new AbortController()
    void getFocusPage(controller.signal, search)
    return () => {
      setPage(null)
      controller.abort()
    }
  }, [])

  return isTabPage ? <TabsPage /> : <PageContent />
}
